import CONSTANTS from '../constants'
import { getRequest } from '../../services'
import { APICONFIG } from '../config/apiConfig'

export const getPassDetailsById = (passId) => (dispatch) => {
    dispatch({ type: CONSTANTS.PASS_DETAILS_REQUEST })
    return getRequest(`${APICONFIG.getUserPassDetails}/${passId}`).then((res) => {
        dispatch({ type: CONSTANTS.PASS_DETAILS_SUCCESS, data: res?.data })
        return res?.data
    }).catch((err) => {
        dispatch({ type: CONSTANTS.PASS_DETAILS_FAILURE })
        return Promise.reject(err)
    })
}
